import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "ActAccessModalStepSetAccessPeriods" }
const _hoisted_2 = { class: "ActAccessModalCheckboxBlock" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = { class: "ActAccessContentSubSection" }
const _hoisted_5 = {
  key: 0,
  class: "DashboardName"
}
const _hoisted_6 = { class: "ActDateWrapper" }
const _hoisted_7 = ["onChange"]
const _hoisted_8 = ["onChange"]
const _hoisted_9 = {
  key: 1,
  class: "InvalidInputMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Set Access Periods", -1 /* CACHED */)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "UsersManagementText" }, " By default, access applies to all selected dashboards. ", -1 /* CACHED */)),
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        checked: !_ctx.sameDatesPerDashboard,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCheckboxClick && _ctx.handleCheckboxClick(...args)))
      }, null, 8 /* PROPS */, _hoisted_3),
      _cache[1] || (_cache[1] = _createTextVNode(" Set different dates per dashboard ", -1 /* CACHED */))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actDashboardsToShowDatesFor, (dashboard, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: dashboard.productNumber,
          class: "DashboardAccessPeriodBlock"
        }, [
          (!_ctx.sameDatesPerDashboard)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(dashboard.productName), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("input", {
              type: "date",
              ref_for: true,
              ref: _ctx.setDatePickerRef(_ctx.datePickerStart, index),
              class: _normalizeClass([
							'ActAccessDatePicker',
							_ctx.retrieveAccessPeriodsValidationIssueForDashboard(dashboard.productNumber, _ctx.dateTypeStart) ? 'ContentInvalid' : ''
						]),
              onChange: ($event: any) => (_ctx.handleDateSet(index, $event, _ctx.dateTypeStart))
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_7),
            _createElementVNode("input", {
              type: "date",
              ref_for: true,
              ref: _ctx.setDatePickerRef(_ctx.datePickerEnd, index),
              class: _normalizeClass([
						'ActAccessDatePicker',
						_ctx.retrieveAccessPeriodsValidationIssueForDashboard(dashboard.productNumber, _ctx.dateTypeEnd) ? 'ContentInvalid' : ''
					]),
              onChange: ($event: any) => (_ctx.handleDateSet(index, $event, _ctx.dateTypeEnd))
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_8)
          ]),
          (_ctx.retrieveAccessPeriodsValidationIssueForDashboard(dashboard.productNumber))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.retrieveAccessPeriodsValidationIssueForDashboard(dashboard.productNumber)?.message), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}